import { useSearchParams, Navigate } from "react-router-dom";
import { LogIn, AlertCircle } from "lucide-react";
import { useAuth } from "../lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const [params] = useSearchParams();
  const error = params.get("error");
  const { user, loading } = useAuth();

  if (loading) return <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6]"><p className="font-body text-[#757575]">Chargement…</p></div>;
  if (user?.is_admin) return <Navigate to="/admin" replace />;

  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div data-testid="page-admin-login" className="min-h-screen flex items-center justify-center bg-[#FAF9F6] px-6">
      <div className="max-w-md w-full">
        <p className="text-xs tracking-[0.3em] uppercase text-[#9E4735] font-body mb-6 text-center">
          Espace administrateur
        </p>
        <h1 className="font-serif text-4xl sm:text-5xl text-[#1A1A1A] leading-tight font-light text-center mb-4">
          Connexion <em className="text-[#2C402E]">CLED</em>
        </h1>
        <p className="text-base text-[#4A4A4A] font-body text-center mb-12">
          L'accès au tableau de bord est réservé à l'administrateur de la maison d'édition.
        </p>

        {error && (
          <div data-testid="login-error" className="border border-[#9E4735] bg-[#FAF9F6] p-4 mb-8 flex gap-3">
            <AlertCircle size={18} className="text-[#9E4735] flex-shrink-0 mt-0.5" />
            <p className="text-sm font-body text-[#1A1A1A]">
              {error === "session_invalid"
                ? "Session invalide ou expirée. Veuillez réessayer."
                : "Erreur de connexion."}
            </p>
          </div>
        )}

        {user && !user.is_admin && (
          <div data-testid="not-admin-error" className="border border-[#9E4735] bg-[#FAF9F6] p-4 mb-8 flex gap-3">
            <AlertCircle size={18} className="text-[#9E4735] flex-shrink-0 mt-0.5" />
            <p className="text-sm font-body text-[#1A1A1A]">
              Compte connecté : {user.email}. Ce compte n'a pas les droits d'administrateur.
            </p>
          </div>
        )}

        <button
          onClick={handleLogin}
          data-testid="google-login-button"
          className="w-full bg-[#2C402E] text-[#FAF9F6] hover:bg-[#1F2D21] px-8 py-4 font-body tracking-wide transition-all flex items-center justify-center gap-3"
        >
          <LogIn size={18} />
          Se connecter avec Google
        </button>

        <p className="text-xs text-[#757575] font-body text-center mt-8">
          Authentification sécurisée via Emergent Auth.
        </p>
      </div>
    </div>
  );
}
